import axios from 'axios';

// GET /admin/tokens-list -> [{ id (tokenId string), type, candidate, candidateId, sponsor,
// sponsorCode, status, assignmentStatus }]. Real replacement for the panel's former mock.
export async function getTokens() {
  try {
    const res = await axios.get('/admin/tokens-list');
    return (res.data && res.data.tokens) || [];
  } catch (error) {
    console.error(error);
    return [];
  }
}
